/**
 * 医療脱毛の新規お試しモニター専用LPへの導線。
 *
 * NOTE: SBDCの価格掲載ルール（公式サイト＝定価 / LP＝新規お試しモニター価格 / 複数回コース＝Web非掲載）
 *       に従い、公式サイト本文・料金表にはモニター価格を転載しない。
 *       ここでは専用LPへの入口のみを設置し、価格訴求はLP側で行う。
 */
const HAIR_REMOVAL_MONITOR_LP_URL = "https://sbscl.biz/990/";

export default function HairRemovalMonitorLink() {
  return (
    <div className="flex flex-col gap-7 border border-accent-300 bg-accent-50/70 p-8 md:flex-row md:items-center md:justify-between md:p-10">
      <div>
        <span className="en-eyebrow text-[10px] text-accent-700 md:text-[11px]">FOR FIRST VISIT</span>
        <p className="mt-4 max-w-2xl font-heading text-[16px] leading-[1.9] text-foreground-900 md:text-lg">
          初めての方限定・医療脱毛モニターのご案内
        </p>
        <p className="mt-3 max-w-2xl text-[12.5px] leading-[2] text-foreground-600">
          初めてご来院いただく方向けの医療脱毛モニターの内容・条件は、専用ページでご案内しています。
        </p>
      </div>
      <a
        href={HAIR_REMOVAL_MONITOR_LP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="group inline-flex shrink-0 items-center justify-center gap-3 whitespace-nowrap rounded-md bg-primary-600 px-8 py-3.5 text-[14px] font-medium text-background-50 transition-colors hover:bg-primary-700"
      >
        医療脱毛モニターを見る
        <i className="ri-external-link-line transition-transform group-hover:translate-x-0.5" aria-hidden />
      </a>
    </div>
  );
}